
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as meYiqjBuGNaISmnC1n8udt23aMBOtyOfczXXSzoT_AQ44Meta } from "/vercel/path0/pages/me.vue?macro=true";
import { default as feedCzRajSqu7_FDDJo1ZS2gVajINXx41WpnTn5ZSRRj8pgMeta } from "/vercel/path0/pages/feed.vue?macro=true";
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as createBxmMhHonEgMOM40RouwHUpt50ldzE9mGfcUED8syFlAMeta } from "/vercel/path0/pages/create.vue?macro=true";
import { default as studioEoiRspR8bnhPHrVboBIaaPsvkGZFpB6J_lToWK0f2acMeta } from "/vercel/path0/pages/studio.vue?macro=true";
import { default as billingJqGeEtfZcZTzGkl4rdoOSEmhqXop5hFfu8EBplIpaUMMeta } from "/vercel/path0/pages/billing.vue?macro=true";
import { default as librarySKluPz0t9d19OZHyQKRZgZR9KK8PH6XYkwbA16GIpFUMeta } from "/vercel/path0/pages/library.vue?macro=true";
import { default as pricingPPf6BeWRpD7HVrIl3nqmmYLxmslMZFDdF0SKMveqHGcMeta } from "/vercel/path0/pages/pricing.vue?macro=true";
import { default as rewardsx2llgBJJ5urT9Jdhtsq_7NcPyuc_45QgcQFphJ1oEW2wkMeta } from "/vercel/path0/pages/rewards.vue?macro=true";
import { default as m_45createUhJ_45ny2eIedaVTQe50rT14naFAtwRI_45WUZ0a2k9tsaIMeta } from "/vercel/path0/pages/m-create.vue?macro=true";
import { default as _91slug_93hEggNBNkYJyc3Ud4KYRRCzcjxeVTqOmTVvxvWYloyeIMeta } from "/vercel/path0/pages/v/[slug].vue?macro=true";
import { default as opsS3Fpjfs4TK_45rPGzmagLDEIn5CnQlQu3XJfGrVUTKS8YMeta } from "/vercel/path0/pages/clips/ops.vue?macro=true";
import { default as copyrightkzM1RF271VcpFUeiudhXeiFjt9cTfkgLeqxc0yk__452AMeta } from "/vercel/path0/pages/copyright.vue?macro=true";
import { default as extensionL234wbMNbjhKZJquG3ymWq0RHxAjn4mOQU_45wwXZrnjsMeta } from "/vercel/path0/pages/extension.vue?macro=true";
import { default as _91id_93ccXw_au1TdoFxdYrXVAIL_455rCvUsio45UeDX05JrwfAMeta } from "/vercel/path0/pages/clips/[id].vue?macro=true";
import { default as indexpjm9u6IJHHc6EeJALJEQ5qQbjD7Y1FjkFsbE_sF7Bo8Meta } from "/vercel/path0/pages/clips/index.vue?macro=true";
import { default as taskszKKfVW56p6WleoOiY2XpB3_45LmW2mXEWgWvOC6yRdwNQMeta } from "/vercel/path0/pages/clips/tasks.vue?macro=true";
import { default as indexh1r4MDZ8gLTn2Qc0f_45_Bw1TZFYETuSG5ptBBpcS_zjkMeta } from "/vercel/path0/pages/music/index.vue?macro=true";
import { default as white_45noiseOWNua0gRTjj18R8C2QlDbTbopTskixszOVJINZzVkdkMeta } from "/vercel/path0/pages/white-noise.vue?macro=true";
import { default as indexNt0kq9Y6rOb7z3yF5LxL5v5rRBoC9c5_ZHg5ik9pyNsMeta } from "/vercel/path0/pages/guides/index.vue?macro=true";
import { default as search9RSb2U8sgl_4p6viAyodj7YtKHLoYeLGY7CaKJOQ2R4Meta } from "/vercel/path0/pages/music/search.vue?macro=true";
import { default as mv_45generator04GwU6_45lFMzqqawcOfg5CSoR7soza0UEeiWypq44KngMeta } from "/vercel/path0/pages/mv-generator.vue?macro=true";
import { default as _91id_930wzMQp7IbTwCu4AYFroGnWFn_45C3y_4550YwlGJ1HYMvqIMeta } from "/vercel/path0/pages/payment/[id].vue?macro=true";
import { default as _91slug_93Np_8AMMYkYN2AgZYfhd9kMktdSUm_JgQtQFKth2EYI8Meta } from "/vercel/path0/pages/share/[slug].vue?macro=true";
import { default as subscriptiondjadAkOwlmKbjZC26GDVpK0JHeeA5UpR4koRzKsS8roMeta } from "/vercel/path0/pages/subscription.vue?macro=true";
import { default as _91id_93DOy0YtD90WUiJAOEPX7Av8lFquyMOdcswX1ybpB6C8kMeta } from "/vercel/path0/pages/checkout/[id].vue?macro=true";
import { default as design_45systemBvRGtEJCqP9afJQYJLPY3vp_45YQ00KgIgay1O3DHojkkMeta } from "/vercel/path0/pages/design-system.vue?macro=true";
import { default as _91slug_938fAB80YdWc4tkrxjF1dmnC1HPs3yOqKMpqcIsfcM1P0Meta } from "/vercel/path0/pages/guides/[slug].vue?macro=true";
import { default as indexflkDDndAHUmv6ejP4guwGfIIuvaO4sicoUiSNAXV_ZsMeta } from "/vercel/path0/pages/discover/index.vue?macro=true";
import { default as templatesz8EwPBggGMMeQEXx4Xltmzh7kXj5dS1bOWb6yDTvZZQMeta } from "/vercel/path0/pages/clips/templates.vue?macro=true";
import { default as _91slug_93W7VPZ8Mf9XkAdVNtvHwGYIadsRUe1LOXyhsLt80_45pVsMeta } from "/vercel/path0/pages/discover/[slug].vue?macro=true";
import { default as _91section_93GyQDbjJ8u7NhIHVuFAPQFD6PVMXxZl1i8iDddFIahpMMeta } from "/vercel/path0/pages/music/[section].vue?macro=true";
import { default as _91id_93uElFIrI_P6JJrWDXpKXAlemYwIX37fR7y8InO99D_WoMeta } from "/vercel/path0/pages/music/song/[id].vue?macro=true";
import { default as short_45video_45kitVopdF1cwlWBI9fdXU_FGH3MsidR56yNFytYNu7mS7G0Meta } from "/vercel/path0/pages/short-video-kit.vue?macro=true";
import { default as _91id_937qMRXe094fW5TKqEYnBUU7tWtfj_7VWq5uGoDxokEAEMeta } from "/vercel/path0/pages/album-cover/[id].vue?macro=true";
import { default as successgbg7mNrm44wgkXgLFs1C0QIyj4TkVcSH2Rs8WS9UM8sMeta } from "/vercel/path0/pages/checkout/success.vue?macro=true";
import { default as insightsIpV3QET8YD6fluVfMOekhQ7Lffsw3te1ZpDc85q3rqwMeta } from "/vercel/path0/pages/creator/insights.vue?macro=true";
import { default as _91id_93gpT4HhZ_p5XorJYuFHRnb1rEqpWYsL4gmsMJKzrIOE0Meta } from "/vercel/path0/pages/lyric-video/[id].vue?macro=true";
import { default as lyrics_45generatorp16_45_45YPvVLWgxZHplyG9tt1pWuP5VZ8f_sToUi3c9scMeta } from "/vercel/path0/pages/lyrics-generator.vue?macro=true";
import { default as vocal_45separationbDa7daNLNURCBE6CHmQCVC40izU1u4h0FGk6mifbF3wMeta } from "/vercel/path0/pages/vocal-separation.vue?macro=true";
import { default as indexEMyOCGAJeZ0kf1XsshjYG98ZZD1t8_45zsKbgfP0SXgZsMeta } from "/vercel/path0/pages/lyric-video/index.vue?macro=true";
import { default as _91share_ref_930_4521bv2FyJkpXOqzAmAKx5dGy1EiDKogLNVam1tMFqYMeta } from "/vercel/path0/pages/invite/[share_ref].vue?macro=true";
import { default as drafts4Y5b48ZM_kGxiXu0t4FTny4YbqwsWcrDGPFtNM9txP8Meta } from "/vercel/path0/pages/lyric-video/drafts.vue?macro=true";
import { default as rap_45name_45generatoruopW776_fw4XT_uVa1g20Vhr3_45hhw5C7BhTdfOQBY0oMeta } from "/vercel/path0/pages/rap-name-generator.vue?macro=true";
import { default as rap_45lyrics_45generatoroBYPC8M3QbSlULHA3TRSOK7gakeUEqVBEmxZw0F4gZcMeta } from "/vercel/path0/pages/rap-lyrics-generator.vue?macro=true";
import { default as indexXqrIpyyCRy2tpy_QHjhv5UxmBkdCztcCrxQpWibxZx4Meta } from "/vercel/path0/pages/[locale]/guides/index.vue?macro=true";
import { default as album_45cover_45generator31hDT4o3W2j_45_45qwlrikM4InyXJYGUcI9hjFg9zolVhIMeta } from "/vercel/path0/pages/album-cover-generator.vue?macro=true";
import { default as _91slug_930dlHlnC38UcT__Xl4um7TNTnTp_45MFSednK4Y_45OhP_45EQMeta } from "/vercel/path0/pages/[locale]/guides/[slug].vue?macro=true";
export default [
  {
    name: "me",
    path: "/me",
    component: () => import("/vercel/path0/pages/me.vue")
  },
  {
    name: "feed",
    path: "/feed",
    meta: feedCzRajSqu7_FDDJo1ZS2gVajINXx41WpnTn5ZSRRj8pgMeta || {},
    component: () => import("/vercel/path0/pages/feed.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/vercel/path0/pages/create.vue")
  },
  {
    name: "studio",
    path: "/studio",
    component: () => import("/vercel/path0/pages/studio.vue")
  },
  {
    name: "billing",
    path: "/billing",
    component: () => import("/vercel/path0/pages/billing.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/vercel/path0/pages/library.vue")
  },
  {
    name: "pricing",
    path: "/pricing",
    component: () => import("/vercel/path0/pages/pricing.vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/vercel/path0/pages/rewards.vue")
  },
  {
    name: "m-create",
    path: "/m-create",
    component: () => import("/vercel/path0/pages/m-create.vue")
  },
  {
    name: "v-slug",
    path: "/v/:slug()",
    meta: { ...(_91slug_93hEggNBNkYJyc3Ud4KYRRCzcjxeVTqOmTVvxvWYloyeIMeta || {}), ...{"middleware":[]} },
    component: () => import("/vercel/path0/pages/v/[slug].vue")
  },
  {
    name: "clips-ops",
    path: "/clips/ops",
    component: () => import("/vercel/path0/pages/clips/ops.vue")
  },
  {
    name: "copyright",
    path: "/copyright",
    meta: {"middleware":["single-certificate"]},
    component: () => import("/vercel/path0/pages/copyright.vue")
  },
  {
    name: "extension",
    path: "/extension",
    component: () => import("/vercel/path0/pages/extension.vue")
  },
  {
    name: "clips-id",
    path: "/clips/:id()",
    component: () => import("/vercel/path0/pages/clips/[id].vue")
  },
  {
    name: "clips",
    path: "/clips",
    component: () => import("/vercel/path0/pages/clips/index.vue")
  },
  {
    name: "clips-tasks",
    path: "/clips/tasks",
    component: () => import("/vercel/path0/pages/clips/tasks.vue")
  },
  {
    name: "music",
    path: "/music",
    component: () => import("/vercel/path0/pages/music/index.vue")
  },
  {
    name: "white-noise",
    path: "/white-noise",
    component: () => import("/vercel/path0/pages/white-noise.vue")
  },
  {
    name: "guides",
    path: "/guides",
    component: () => import("/vercel/path0/pages/guides/index.vue")
  },
  {
    name: "music-search",
    path: "/music/search",
    component: () => import("/vercel/path0/pages/music/search.vue")
  },
  {
    name: "mv-generator",
    path: "/mv-generator",
    component: () => import("/vercel/path0/pages/mv-generator.vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/vercel/path0/pages/payment/[id].vue")
  },
  {
    name: "share-slug",
    path: "/share/:slug()",
    meta: { ...(_91slug_93Np_8AMMYkYN2AgZYfhd9kMktdSUm_JgQtQFKth2EYI8Meta || {}), ...{"middleware":[]} },
    component: () => import("/vercel/path0/pages/share/[slug].vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    meta: subscriptiondjadAkOwlmKbjZC26GDVpK0JHeeA5UpR4koRzKsS8roMeta || {},
    component: () => import("/vercel/path0/pages/subscription.vue")
  },
  {
    name: "checkout-id",
    path: "/checkout/:id()",
    component: () => import("/vercel/path0/pages/checkout/[id].vue")
  },
  {
    name: "design-system",
    path: "/design-system",
    meta: design_45systemBvRGtEJCqP9afJQYJLPY3vp_45YQ00KgIgay1O3DHojkkMeta || {},
    component: () => import("/vercel/path0/pages/design-system.vue")
  },
  {
    name: "guides-slug",
    path: "/guides/:slug()",
    component: () => import("/vercel/path0/pages/guides/[slug].vue")
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/vercel/path0/pages/discover/index.vue")
  },
  {
    name: "clips-templates",
    path: "/clips/templates",
    component: () => import("/vercel/path0/pages/clips/templates.vue")
  },
  {
    name: "discover-slug",
    path: "/discover/:slug()",
    component: () => import("/vercel/path0/pages/discover/[slug].vue")
  },
  {
    name: "music-section",
    path: "/music/:section()",
    component: () => import("/vercel/path0/pages/music/[section].vue")
  },
  {
    name: "music-song-id",
    path: "/music/song/:id()",
    component: () => import("/vercel/path0/pages/music/song/[id].vue")
  },
  {
    name: "short-video-kit",
    path: "/short-video-kit",
    meta: short_45video_45kitVopdF1cwlWBI9fdXU_FGH3MsidR56yNFytYNu7mS7G0Meta || {},
    component: () => import("/vercel/path0/pages/short-video-kit.vue")
  },
  {
    name: "album-cover-id",
    path: "/album-cover/:id()",
    component: () => import("/vercel/path0/pages/album-cover/[id].vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    component: () => import("/vercel/path0/pages/checkout/success.vue")
  },
  {
    name: "creator-insights",
    path: "/creator/insights",
    component: () => import("/vercel/path0/pages/creator/insights.vue")
  },
  {
    name: "lyric-video-id",
    path: "/lyric-video/:id()",
    meta: _91id_93gpT4HhZ_p5XorJYuFHRnb1rEqpWYsL4gmsMJKzrIOE0Meta || {},
    component: () => import("/vercel/path0/pages/lyric-video/[id].vue")
  },
  {
    name: "lyrics-generator",
    path: "/lyrics-generator",
    component: () => import("/vercel/path0/pages/lyrics-generator.vue")
  },
  {
    name: "vocal-separation",
    path: "/vocal-separation",
    component: () => import("/vercel/path0/pages/vocal-separation.vue")
  },
  {
    name: "lyric-video",
    path: "/lyric-video",
    meta: indexEMyOCGAJeZ0kf1XsshjYG98ZZD1t8_45zsKbgfP0SXgZsMeta || {},
    component: () => import("/vercel/path0/pages/lyric-video/index.vue")
  },
  {
    name: "invite-share_ref",
    path: "/invite/:share_ref()",
    component: () => import("/vercel/path0/pages/invite/[share_ref].vue")
  },
  {
    name: "lyric-video-drafts",
    path: "/lyric-video/drafts",
    meta: drafts4Y5b48ZM_kGxiXu0t4FTny4YbqwsWcrDGPFtNM9txP8Meta || {},
    component: () => import("/vercel/path0/pages/lyric-video/drafts.vue")
  },
  {
    name: "rap-name-generator",
    path: "/rap-name-generator",
    component: () => import("/vercel/path0/pages/rap-name-generator.vue")
  },
  {
    name: "rap-lyrics-generator",
    path: "/rap-lyrics-generator",
    component: () => import("/vercel/path0/pages/rap-lyrics-generator.vue")
  },
  {
    name: "locale-guides",
    path: "/:locale()/guides",
    component: () => import("/vercel/path0/pages/[locale]/guides/index.vue")
  },
  {
    name: "album-cover-generator",
    path: "/album-cover-generator",
    component: () => import("/vercel/path0/pages/album-cover-generator.vue")
  },
  {
    name: "locale-guides-slug",
    path: "/:locale()/guides/:slug()",
    component: () => import("/vercel/path0/pages/[locale]/guides/[slug].vue")
  }
]